import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://ap2.chinet.org/api/v1",
});

axiosInstance.interceptors.request.use(
  function(config) {
    const token = window.localStorage.CHIAuPairAuthToken;
    if (token) config.headers.Authorization = token;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export const api = {
  get(endpoint) {
    return axiosInstance.get(endpoint);
  },

  post(endpoint, data) {
    return axiosInstance.post(endpoint, data);
  },

  delete(endpoint) {
    return axiosInstance.delete(endpoint);
  },
  login(body) {
    return axiosInstance.post("/Account/login", body);
  },

  validate() {
    return axiosInstance.post("/Account/validate");
  },
  createHf(data) {
    return axiosInstance.post("/promotional/HostFamily/user", data.state.user);
  },
  editHf(data) {
    return axiosInstance.put("/promotional/HostFamily/user", data);
  },
  remember(body) {
    return axios.post(
      "https://ap2.chinet.org/api/v1/Account/hf-forgot-password",
      body
    );
  },
  resetUserPassword(body) {
    return axios.post(
      "https://ap2.chinet.org/api/v1/Account/reset-password",
      body
    );
  },
};
